module.exports = __webpack_public_path__ + "static/monofocus-promo-4456cfa33644bdb086d9a02b89d5ece7.mp4";